<template>
  <div class="rich-text">
    <!-- 是否是列表模式，是否权限只读，是否有值，是否显示 -->
    <el-popover placement="bottom-start" width="400" trigger="manual" v-if="onlyValue" v-model="show" :disabled="readonly" ref="popover">
      <div class="only-value-rich" v-if="!readonly && show">
        <WangEditor ref="WangEditor" maxHeight="601px" height="495px" :showBtn="true" :textInfo="currentValue" @editorCancel="editorCancel" @editorSubmit="editorSubmit"  :isTaskDetail="true"></WangEditor>
      </div>
      <div slot="reference" :class="{'show-txt-rest':readonly,'blur-border': show,'visible-onlyValue': (currentValue || readonly) && !isNull}" class="table-select-box" @click="closeRich">
        <div class="table-select-onlyValue" v-if="(currentValue || readonly) && !isNull">
          <toolTip style="width:100%"  :title="notImgHtml" :disabled="show" place="bottom" :interactive="true" :appendTo="$refs['rich-text']">
            <span class="rich-box-html">
              <i class="icon iconfont iconicon_picture" v-if="isHasImg"></i>
              {{textValue}}
            </span>
          </toolTip>
        </div>
        <p v-else class="table-select-button">
          <span v-if="readonly">暂无</span>
          <span v-else><i class="el-icon-circle-plus"></i>添加</span>
        </p>
      </div>
    </el-popover>
    <div class="rich-box" v-else>
      <div class="edit-component" v-if="show">
        <WangEditor :textInfo="currentValue" @editorCancel="editorCancel" @editorSubmit="editorSubmit" :isTaskDetail="isTaskDetail" :showTop="true" @blur="onBlur"></WangEditor>
      </div>
      <div class="rich-content" :class="{'show-txt-rest':readonly}" :style="{'max-height':handelMore && inHeight > 60 ? inHeight + 8 + 'px' : '583px'}" v-else-if="(currentValue && !isNull) || readonly" ref="show-txt">
        <div class="rich-box-text show-txt" ref="only-value" v-html="htmlValue" @click="addValue"></div>
      </div>
      <p class="add-txt" v-else @click="addValue">添加</p>
      <div v-if="isMax && !show" class="more-box" @click="handelMore = !handelMore">
        <div class="more-msg" v-if="!handelMore">查看更多<i class="icon iconfont iconicon_arrow_task"></i></div>
        <div class="more-msg" v-else>收起<i class="icon iconfont iconicon_arrow_task2"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import WangEditor from '@/components/wangEditor'
import { createEditor } from '@wangeditor/editor'
import bus from '@/bus'
import elementResizeDetectorMaker from 'element-resize-detector'
export default {
  components: {
    WangEditor
  },
  props: ['config', 'value', 'defaultValue', 'onlyValue', 'readonly', 'isTaskDetail', 'isTemplate'],
  computed: {
    currentValue: {
      get: function () {
        console.log('---------', this.value, !this.value)
        if (!this.value) {
          this.isMax = false
          this.htmlValue = ''
        } else {
          this.htmlValue = createEditor({ content: JSON.parse(this.value) }).getHtml()
          this.textValue = createEditor({ content: JSON.parse(this.value) }).getText().replace(/\ +/g, '').replace(/[ ]/g, '').replace(/[\r\n]/g, '') // 去除空格回车换行
          this.getNotImgHtml()
          const _text = this.textValue.replace(/\s+/g, "").replace(/&nbsp+/g, "")
          if (this.htmlValue.indexOf('<img') < 0 && !_text) {
            this.isNull = true
            this.isMax = false
          } else {
            this.isNull = false
          }
        }
        return this.value || `[{\"type\":\"paragraph\",\"children\":[{\"text\":\"\"}]}]`
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    }
  },
  data() {
    return {
      show: false,
      isMax: false,
      handelMore: false,
      htmlValue: '',
      inHeight: 0,
      notImgHtml: '',
      textValue: '',
      isNull: true,
      isHasImg: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    if (this.onlyValue) {
      document.addEventListener('click', this.closePopover)
    } else {
      // this.handelChange()
      this.lisenteEle()
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePopover)
  },
  methods: {
    lisenteEle() {
      this.$nextTick(() => {
        if (!this.$refs['only-value']) return
        this.erd = elementResizeDetectorMaker();
        this.erd.listenTo(this.$refs['only-value'], async (ele) => {
          this.handelChange()
        })
      })
    },
    closeRich() {
      this.show = true
    },
    closePopover(e) {
      if (this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        if (this.show == true) {
          this.show = false
        }
      }
    },
    getNotImgHtml() {
      if (this.htmlValue) {
        let regImg = /<img.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/ig
        let regVideo = /<video.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/ig
        this.notImgHtml = this.htmlValue
        this.notImgHtml = this.notImgHtml.replace(regImg, '<p>[图片]</p>')
        this.notImgHtml = this.notImgHtml.replace(regVideo, '<p>[视频]</p>')
        if(regImg.test(this.htmlValue) || regVideo.test(this.htmlValue)) {
          this.isHasImg = true
        } else {
          this.isHasImg = false
        }
      }
    },
    handelChange() {
      this.$nextTick(() => {
        if (!this.$refs['show-txt'] || !this.$refs['only-value']) {
          return
        }
        if (!this.$refs['only-value']) {
          this.isMax = false
        }
        let ele = this.$refs['only-value']
        let inHeight = ele.offsetHeight
        this.inHeight = inHeight
        if (inHeight > 583) {
          this.isMax = true
        } else {
          this.isMax = false
        }
      })
    },
    init() {
      if(this.isTemplate) {
        this.$emit("input", this.defaultValue)
      }  else if (this.defaultValue && this.defaultValue.length > 0) {
        let val = this.getDefaultValue(this.defaultValue)
        this.$emit('input', val)
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value
      }
    },
    addValue(e) {
      if (this.onlyValue || this.readonly) {
        if (e.target.tagName === 'IMG') {
          this.$viewerApi({
            images: [e.target.currentSrc],
          })
        }
        return
      }
      !this.onlyValue && this.handelChange()
      this.show = true
    },
    editorCancel() {
      this.show = false
    },
    onBlur(html) {
      this.editorSubmit(html)
    },
    editorSubmit(html) {
      this.show = false
      let value = html
      if (JSON.stringify(value) === JSON.stringify(this.currentValue)) return
      this.currentValue = value
      this.$emit('change', value)
      this.$nextTick(() => {
        !this.onlyValue && this.handelChange()
        this.handelMore = true
      })
    },
    getMessage(res) {
      let fn = (val) => {
        let regImg = /<img.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/ig
        let regVideo = /<video.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/ig
        let value = createEditor({ content: JSON.parse(val) }).getHtml()
        return value.replace(regImg, ' [图片] ').replace(regVideo, ' [视频] ').replace(/<[^>]*>/g, '')
      }
      let str = ''
      try {
        str = `
        <span class="message-mixin-tip">将${res.field_name}修改为</span>
        <span class="message-mixin-task rich-message">${res.new_data && typeof res.new_data === 'string' && fn(res.new_data) ? fn(res.new_data) : `<span class="message-mixin-tip">无</span>`}</span>`
      } catch (error) {

      }
      return str
    },
    // closed() {
    //   this.$refs.WangEditor.handleSubmit()
    // }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.rich-text {
  // width: 100%;
  overflow: hidden;
  // height: 100%;
  a[href]{
    &:hover{
      text-decoration: underline !important;
    }
  }
  ul li {
    list-style: disc;
  }
  ol li {
    list-style: decimal;
  }
  ul,
  ol {
    padding-left: 0;
  }
  .show-txt-rest {
    cursor: auto;
    .rich-box-text img {
      cursor: zoom-in;
    }
    .show-txt:hover {
      background-color: initial;
    }
  }
  .rich-box {
    // height: 100%;
    // >* {
    //   height: 100%;
    // }
    min-width: 500px;
    width: 100%;
    p {
      text-align: initial;
    }
    .add-txt {
      height: auto;
    }
  }
  .rich-content {
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    width: 100%;
    .show-txt {
      display: block;
    }
  }
  .edit-component {
    .w-e-scroll {
      &>div {
        min-height: 200px;
      }
    }
  }
  .more-box {
    font-size: 14px;
    color: #509aff;
    padding-left: 8px;
    cursor: pointer;
    padding-top: 10px;
    i {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  .rich-box-html {
    i {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
    }
  }
  .show-txt-rest {
    cursor: auto;
    .rich-box-text img {
      cursor: zoom-in;
    }
    .show-txt:hover {
      background-color: initial;
    }
  }
  .rich-box-text {
    line-height: 1.5;
    padding: 8px;
    // padding: 8px 8px 0;
    // min-height: 40px;
    img {
      max-width: 100%;
    }
  }
  .editor-con {
    > div:first-child {
      padding-right: 200px;
    }
  }
}
.only-value-rich {
  // max-height: 50vh;
  // overflow-x: auto;
  height: 601px;
  .w-e-toolbar {
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .w-e-text-container [data-slate-editor] {
    padding: 0;
    margin: 0 24px;
  }
  .w-e-text-placeholder {
    left: 24px;
  }
  .editor-con{
    border: 0 none !important;
  }
}
</style>
